var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{ref:"myChart",style:({ width: 'auto', height: '300px' })})])])}
var staticRenderFns = []

export { render, staticRenderFns }